import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

import "../styles/ScrollDownIndicator.css";

export default function ScrollDownIndicator({ targetId, className = "" }) {
  const { t } = useTranslation();
  const [isNeeded, setIsNeeded] = useState(true);

  useEffect(() => {
    const target = document.getElementById(targetId);
    if (!target) {
      setIsNeeded(false);
      return;
    }

    const updateVisibility = () => {
      setIsNeeded(target.getBoundingClientRect().top > window.innerHeight);
    };

    updateVisibility();
    window.addEventListener("scroll", updateVisibility, { passive: true });
    window.addEventListener("resize", updateVisibility);

    return () => {
      window.removeEventListener("scroll", updateVisibility);
      window.removeEventListener("resize", updateVisibility);
    };
  }, [targetId]);

  const scrollToContent = () => {
    const target = document.getElementById(targetId);
    if (!target) return;

    const navbarHeight =
      document.querySelector(".navbar")?.getBoundingClientRect().height || 0;
    const reducedMotion = window.matchMedia(
      "(prefers-reduced-motion: reduce)",
    ).matches;

    window.scrollTo({
      top: Math.max(
        0,
        window.scrollY +
          target.getBoundingClientRect().top -
          navbarHeight -
          200,
      ),
      behavior: reducedMotion ? "auto" : "smooth",
    });
  };

  return (
    <div className={`scroll-down-indicator ${className}`}>
      <button
        type="button"
        className="scroll-down-indicator-button"
        onClick={scrollToContent}
        aria-label={t("scroll_down_to_content")}
        title={t("scroll_down_to_content")}
        aria-controls={targetId}
        style={{ visibility: isNeeded ? "visible" : "hidden" }}
      >
        <svg
          className="scroll-down-indicator-arrow"
          width="48"
          height="32"
          viewBox="0 0 48 32"
          fill="none"
          aria-hidden="true"
        >
          <path d="M5 7L24 26L43 7" stroke="currentColor" strokeWidth="2" />
        </svg>
      </button>
    </div>
  );
}
